import { Component, Input } from '@angular/core';
import { MediaPictureService } from '../../../../../../services/media-picture.service';
import { FavoriteCardTypeEnum, UserFavoriteCardData } from '../../../../user-favorite-data.model';

@Component({
  selector: 'flights-header',
  template: `
    <div class="airline-container {{cardType}}">
      <ng-container *ngFor="let airline of data.airlines">
        <img class="airline-logo" [src]="mediaPictureService.getMediaUrl(airline.logo_url)" [alt]="airline.name"/>
      </ng-container>
      <span *ngIf="data.airlines.length === 1" class="airline-name">{{ data.airlines[0].name }}</span>
    </div>
    <favorite-card-drivers *ngIf="data?.drivers" [data]="data"></favorite-card-drivers>
  `,
  styles: [
    `
      .airline-logo {
        height: 33px;
      }

      .airline-name {
        font-size: 12px;
        color: #323439;
        font-weight: 500;
      }
      .REDUCED .airline-name {
        font-weight: 400;
      }

      .airline-container {
        display: flex;
        gap: 8px;
        align-items: center;
      }
    `,
  ],
})
export class FlightsHeaderComponent {
  @Input() data: UserFavoriteCardData;
  @Input() locale: string;
  @Input() flow: string;
  @Input() cardType: FavoriteCardTypeEnum;

  constructor(public mediaPictureService: MediaPictureService) {}
}
